import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

//- Material UI / Style
import { withStyles } from '@material-ui/core/styles';
//containers
import AuthUserContainer from '../../containers/AuthUser';
import LocationContainer from '../../containers/Location';
//- UI / Form
import FormText from '../../components/form/FormText';
import FormSelect from '../../components/form/FormSelect';
import FormActions from '../../components/form/FormActions';
import FormContainer from '../../components/FormContainer';
import { LOCATION_TYPE_IDS } from '../../libs/location';

const styles = () => {
	return {};
};

class SaveLocation extends Component {
	constructor(props) {
		super(props);

		const action = _.get(this.props, 'match.params.action');
		const locationId = parseInt(_.get(this.props, 'match.params.locationId'), 10);
		const isUpdate = action === 'update';

		this.state = {
			isUpdate,
			locationId,
			formFieldError: {},
		};
	}

	componentDidMount() {
		const { location, getLocation } = this.props;
		const { locationId, isUpdate } = this.state;

		if (!isUpdate) {
			return;
		}

		if (location) {
			this.fillForm({ location });
		} else {
			getLocation({
				params: { locationIds: [locationId] },
			});
		}
	}

	componentDidUpdate(prevProps, prevState, snapShot) {
		const { location } = this.props;

		if (_.isUndefined(prevProps.location) && !_.isUndefined(location)) {
			this.fillForm({ location });
		}
	}

	fillForm = ({ location }) => {
		if (!location) {
			return;
		}

		const newState = Object.keys(location).reduce((acc, key) => {
			const value = location[key];
			if (key === 'dateCreated' || _.isNil(value)) {
				return acc;
			}

			acc[key] = value;
			return acc;
		}, {});

		this.setState(newState);
	};

	//- Path is always a string
	//- value is never an event (value.target)
	onChange = (value, path) => {
		const arrayPath = _.toPath(path);
		const basePath = _.head(arrayPath);
		let base = this.state[basePath];
		let newState = {};

		if (_.isArray(base) || _.isObject(base)) {
			base = _.cloneDeep(base);
			_.set(base, arrayPath.slice(1), value);
			newState[basePath] = base;
		} else {
			newState[basePath] = value;
		}

		//- Clear any errors on the path
		let formFieldError = Object.assign({}, this.state.formFieldError);
		delete formFieldError[path];
		newState.formFieldError = formFieldError;

		this.setState(newState);
	};

	goBackToList = () => {
		this.props.history.push(`/location/${LOCATION_TYPE_IDS['truck-terminal']}`);
	};

	handleSave = ({ callback }) => {
		const { addLocation, updateLocation, showErrors } = this.props;

		const { isUpdate, locationId } = this.state;

		const formFieldError = {};

		const requiredFields = [{ path: 'display', label: 'Display' }];

		requiredFields.forEach(({ path, label }) => {
			if (!this.state[path]) {
				formFieldError[path] = `${label} is required`;
			}
		});

		const { display, shortDisplay } = this.state;

		//- Get all the values and do individual checks
		if (_.keys(formFieldError).length) {
			this.setState({ formFieldError });
			showErrors(_.values(formFieldError));
			return;
		}

		const params = {
			display,
			shortDisplay,
		};

		if (!isUpdate) {
			params.locationTypeId = LOCATION_TYPE_IDS['truck-terminal'];
			addLocation({
				params,
				callback,
			});
		} else {
			params.locationId = locationId;
			updateLocation({
				params,
				callback,
			});
		}
	};

	handleDelete = ({ callback }) => {
		const { removeLocation } = this.props;
		const { locationId } = this.state;

		removeLocation({
			locationId,
			callback,
		});
	};

	getInputProps = (path, defaultValue) => {
		return {
			key: path,
			path,
			value: this.getValue(path, defaultValue),
			checked: this.getValue(path, defaultValue),
			error: this.getError(path),
			onChange: this.onChange,
			gridProps: { md: 12 },
		};
	};

	getValue = (path, defaultValue) => {
		const _d = _.isUndefined(defaultValue) ? '' : defaultValue;
		return _.get(this.state, path, _d);
	};

	getError = (path) => {
		return _.get(this.state.formFieldError, path);
	};

	render() {
		const { isUpdate } = this.state;
		const { showErrors } = this.props;

		const action = isUpdate ? 'Update' : 'Add';
		return (
			<FormContainer headline={`${action} Terminal`}>
				<FormText label="Terminal Name" {...this.getInputProps('display')} gridProps={{ sm: 8 }} />
				<FormText
					label="Short Name"
					helpText="Brief description for display purposes"
					{...this.getInputProps('shortDisplay')}
					gridProps={{ sm: 8 }}
				/>

				{[].map((metaField) => {
					const { prop, label, helpText, options } = metaField;

					if (options) {
						return (
							<FormSelect
								key={prop}
								label={label}
								options={options}
								helpText={helpText}
								{...this.getInputProps(prop)}
								gridProps={{ sm: 6 }}
							/>
						);
					}

					return (
						<FormText
							key={prop}
							label={label}
							helpText={helpText}
							{...this.getInputProps(prop)}
							gridProps={{ sm: 6 }}
						/>
					);
				})}

				<FormActions
					onSave={this.handleSave}
					onCancel={this.goBackToList}
					onDone={this.goBackToList}
					onDelete={isUpdate ? this.handleDelete : undefined}
					onError={showErrors}
					saveButtonText={`${action} Terminal`}
					saveProgressText={isUpdate ? 'Updating truck' : 'Creating new truck'}
					saveSuccessText={'Truck saved successfully. Thank you.'}
				/>
			</FormContainer>
		);
	}
}

SaveLocation.propTypes = {
	addLocation: PropTypes.func.isRequired,
	updateLocation: PropTypes.func.isRequired,
	location: PropTypes.object,

	showErrors: PropTypes.func.isRequired,
	authLocation: PropTypes.object,
	classes: PropTypes.object.isRequired,
};

export default _.flow([withStyles(styles), AuthUserContainer, LocationContainer])(SaveLocation);
